import { C8AttributeId, C8NodeType } from "csi/typings";
 
export const TYPE_FOOD_SOURCE: C8NodeType = "FoodSource";

export const ATTR_SOURCING_SOURCES: C8AttributeId = "ProductSources";

export const ATTR_SOURCE_SUPPLIER_ITEMS: C8AttributeId = "SupplierItems";
